import React, { useState } from 'react';
import ProductTopSection from '../../../../components/Sangjo-Ujieon/ProductTopSection';
import ProductSubHeading from '../../../../components/Sangjo-Ujieon/ProductSubHeading';
import FuneralTabMobile from '../../../../components/Sangjo-Ujieon/FuneralTabMobile';
import rectangle1 from '../../../../assets/img/product-info/rectangle1.png';
import rectangle2 from '../../../../assets/img/product-info/rectangle2.png';
import rectangle3 from '../../../../assets/img/product-info/rectangle3.png';

const FuneralInfoOtherMobile = () => {


  return (
    <div className="announcement-list-page product-info-page">
      <ProductTopSection />

      {/* Main Content */}
      <main className="main-content">
        <ProductSubHeading heading="장례정보" />

        {/* Main Content Section */}
        <div className="funeral-info-other-mobile-section">

          {/* Funeral Info Other Section */}
          <div className="funeral-info-other-procedures-section sky-hall-special-room-mobile-pricing-section">
            <FuneralTabMobile selectedHall="기타" />

            {/* Content Display Area */}
            <div className="funeral-info-other-content-area">

              {/* 상주의 우선순위 Section 1 */}
              <div className="funeral-info-other-priority-section">
                <h4 className="funeral-info-other-priority-title">상주의 우선순위</h4>
                <ul className="funeral-info-other-priority-list">
                  <li className="funeral-info-other-priority-item">
                    자손이 없을 경우에는 가장 가까운 촌수의 친족 중에서 나이 많은 자가 된다.
                  </li>
                  <li className="funeral-info-other-priority-item">
                    아내의 상(喪)에는 남편이 된다.
                  </li>
                </ul>
              </div>

              {/* 상주의 우선순위 Section 2 */}
              <div className="funeral-info-other-priority-section">
                <h4 className="funeral-info-other-priority-title">상주의 우선순위</h4>
                <ul className="funeral-info-other-priority-list">
                  <li className="funeral-info-other-priority-item">
                    상사에서 안의 일을 주관하는 사람을 주부(主婦)라 하는데, 주부는 죽은 사람의 아내가 된다.
                  </li>
                  <li className="funeral-info-other-priority-item">
                    아내가 없으면 상주의 아내가 된다.
                  </li>
                </ul>
              </div>

              {/* Priority Ranking Circles */}
              <div className="funeral-info-other-priority-ranking-section">
                <div className="funeral-info-other-priority-circles-container">
                  <div className="funeral-info-other-priority-circle">
                    <span className="funeral-info-other-priority-circle-text">1순위</span>
                    <span className="funeral-info-other-priority-circle-subtext">죽은 사람의 장자(長子)</span>
                  </div>
                  <div className="funeral-info-other-priority-circle">
                    <span className="funeral-info-other-priority-circle-text">2순위</span>
                    <span className="funeral-info-other-priority-circle-subtext">장자가 없으면 장손</span>
                  </div>
                  <div className="funeral-info-other-priority-circle">
                    <span className="funeral-info-other-priority-circle-text">3순위</span>
                    <span className="funeral-info-other-priority-circle-subtext">죽은 사람의 장자(長子)</span>
                  </div>
                </div>
              </div>

              {/* Chief Mourner Section */}
              <div className="funeral-info-other-chief-mourner-section">
                <h4 className="funeral-info-other-chief-mourner-title">주상</h4>
                <ul className="funeral-info-other-chief-mourner-list">
                  <li className="funeral-info-other-chief-mourner-item">
                  검정예복에는 완장을 착용하는데 상주의 외쪽 팔에 차는 것이며 근친 간을 구분하기 위하여 상주 표시로 검은 좋을 넣었으나 요즘 일부 업소에서는 너무 많은 줄을 사용함으로써 모든 사람들에게 혼란을 주고 있다.
                  </li>
                </ul>
              </div>

              <div className="funeral-information-other-mourning-types">
                  <div className="funeral-information-other-mourning-type">
                    <img src={rectangle1} alt="rectangle1" />
                    <div className="funeral-information-other-type-content">
                      <span className="funeral-information-other-label">두줄</span> - 상주 (상제 중 맏이가 되는 자)
                    </div>
                  </div>
                  <div className="funeral-information-other-mourning-type">
                    <img src={rectangle2} alt="rectangle2" />
                    <div className="funeral-information-other-type-content">
                      <span className="funeral-information-other-label">한줄</span> - 상제(상주 이외의 형제자매)
                    </div>
                  </div>
                  <div className="funeral-information-other-mourning-type">
                    <img src={rectangle3} alt="rectangle3" />
                    <div className="funeral-information-other-type-content">
                      <span className="funeral-information-other-label">무줄</span> - 상주 이외 복인들, 8촌 이내
                    </div>
                  </div>
                </div>

              {/* Additional Notes Section */}
              <div className="funeral-info-other-notes-section">
                <ul className="funeral-info-other-notes-list">
                  <li className="funeral-info-other-notes-item">
                    <span>여상복</span> - 우리의 상복은 하얀 옷 또는 광목으로 입었으나 현재는 검정 또는 흰색 치마저고리를 입기도 한다.
                  </li>
                  <li className="funeral-info-other-notes-item">
                    자녀상 중에서 자녀의 후사가 없을 경우 고인의 부모 또는 형제가 주상으로서 역할을 하기도 한다.
                  </li>
                </ul>
              </div>

              
            </div>
          </div>
        </div>
      </main>

    </div>
  );
};

export default FuneralInfoOtherMobile; 